import styled from 'styled-components';

export const MenuItemContainer = styled.div`
  width: 100%;
  display: inline-flex;
  box-sizing: border-box;
`;

export const BorderedMenuItemContainer = styled(MenuItemContainer)`
  border-bottom: 1px solid ${p => p.theme.c.border.primary};
`;

export const BorderedMenuItemContainerTop = styled(BorderedMenuItemContainer)`
`;

export const ImgAlignRightSpan = styled.span`
  padding-right: ${p => p.theme.unit(1.25)};
`;

export const ImgAlignLeftSpan = styled.span`
  padding-left: ${p => p.theme.unit(1.25)};
`;

export const ImgAlignTopSpan = styled.span`
  padding-top: ${p => p.theme.unit(0.5)};
`;

export const LightLinkAnchor = styled.a`
  ${(p) => p.theme.typographyRebrand.body.md};
  color: ${(p) => p.theme.c.text.interactive};
  display: inline-flex;
  align-items: center;
  height: ${p => p.theme.unit(5)};
  width: 100%;
  text-decoration: none;
  margin: 6px;
  :hover {
    text-decoration: underline;
    background-color: ${p => p.theme.c.bg.secondary};
  }
  cursor: pointer;
`;

export const LightButton = styled(LightLinkAnchor.withComponent('button'))`
  padding: 0;
  border: none;
  background-color: transparent;
  > * {
    pointer-events: none;
  }
`;

export const LightBackButton = styled(LightLinkAnchor.withComponent('button'))`
  padding: 0;
  border: none;
  background-color: transparent;
  height: ${p => p.theme.unit(6)};
  > * {
    pointer-events: none;
  }
`;

export const BorderedLinkAnchor = styled(LightLinkAnchor)`
  border-bottom: 1px solid ${p => p.theme.c.border.primary};
`;

export const BorderedButton = styled(LightButton)`
  border-bottom: 1px solid ${p => p.theme.c.border.primary};
`;

export const LightTitleSpan = styled.span`
  ${(p) => p.theme.typographyRebrand.body.md};
  color: ${(p) => p.theme.c.text.interactive};
  padding-top: ${p => p.theme.unit(0.5)};
  padding-left: ${p => p.theme.unit(1.25)};
  padding-right: ${p => p.theme.unit(1.25)};
  text-decoration: none;
  text-align: left;
`;

export const BoldTitleSpan = styled(LightTitleSpan)``;

export const BackButtonTitleSpan = styled(BoldTitleSpan)`
  ${({ theme }) => theme.typographyRebrand.heading.sm}
  padding-top: 0;
  padding-left: ${p => p.theme.unit(1)};
`;

export const CategoryTitleSpan = styled(BoldTitleSpan)`
  padding-left: 0;
`;

export const CategoryIconImg = styled.img`
  width: ${p => p.theme.unit(3)};
  padding: 0 ${p => p.theme.unit(2)};
`;

export const FlexSpaceBetweenDiv = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const FlexCenterDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CategoryHeaderDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.heading.xl}
  color: ${({ theme }) => theme.c.text.primary};
  text-transform: uppercase;
  padding-top: ${p => p.theme.unit(3)};
  padding-bottom: ${p => p.theme.unit(1)};
  padding-left: ${p => p.theme.unit(2)};
`;

export const AirmilesHomeWrapper = styled.div`
  background-color: ${p => p.theme.c.bg.secondary};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 6px;
`;

export const AirmilesHomeAnchor = styled.a`
  display: inline-flex;
  align-items: center;
  width: 100%;
  text-decoration: none;
  margin: 0;
  :hover {
    text-decoration: underline;
  }
  cursor: pointer;
  ${p => p.theme.typographyRebrand.body.md};
  color: ${p => p.theme.c.text.interactive};
  img {
    margin: 4px 16px;
  }
`;
